import { render } from "./TheConsumerListItem.vue?vue&type=template&id=4ff3a2d2&scoped=true&ts=true&lang=html"
import script from "./TheConsumerListItem.vue?vue&type=script&lang=ts"
export * from "./TheConsumerListItem.vue?vue&type=script&lang=ts"

import "./TheConsumerListItem.vue?vue&type=style&index=0&id=4ff3a2d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff3a2d2"]])

export default __exports__